import { ProcessoRelacionamento } from './../processo-relacionamento/processo-relacionamento.model';
import { Competencia } from './../competencia/competencia.model';
import { OrgaoJustica } from './..//orgao-justica/orgao-justica.model';
import { Usuario } from './../usuario/usuario.model';
import { NivelSigilo } from '../models/nivel-sigilo.enum';
import { BaseEntityAuditada } from '../models/base-entity-auditada.model';
import { FonteDados } from '../fonte-dados/fonte-dados.model';
import { ProcessoClasse } from '../processo-classe/processo-classe.model';
import { ProcessoDistribuicao } from '../processo-distribuicao/processo-distribuicao.model';
import { Assunto, ProcessoAssunto } from '../processo-assunto/processo-assunto.model';
import { ProcessoDocumento } from '../processo-documento/processo-documento.model';
import { ProcessoMovimento } from '../processo-movimento/processo-movimento.model';
import { PeticaoInicialFiltro } from '../models/peticao-inicial-filtro.enum ';
import { ProcessoParte } from '../processo-parte/processo-parte.model';

export interface Processo extends BaseEntityAuditada {
  id: number;
  fonteDados: FonteDados;
  orgaoJustica: OrgaoJustica;
  origemId: string;
  numero: string;
  instancia: ProcessoInstancia;
  dataAjuizamento: Date;
  justicaGratuita: boolean;
  nivelSigilo: NivelSigilo;
  liminar: boolean;
  valorCausa: number;
  competencia: Competencia;
  classeAtual: ProcessoClasse;
  distribuicaoAtual: ProcessoDistribuicao;
  assuntos: ProcessoAssunto[];
  documentos: ProcessoDocumento[];
  historicoClasses: ProcessoClasse[];
  historicoDistribuicoes: ProcessoDistribuicao[];
  movimentos: ProcessoMovimento[];
  partes: ProcessoParte[];
  relacionamentos: ProcessoRelacionamento[];
  peticaoInicial: ProcessoDocumento;
  dataAnalisePeticaoInicialAutomatica: Date;
  dataAnalisePeticaoInicialManual: Date;
  analisePeticaoInicialUsuario: Usuario;
  peticaoInicialFiltro: PeticaoInicialFiltro;
  assuntoPrincipal: Assunto;
}

export enum ProcessoInstancia {
  PRIMEIRO_GRAU = 'PRIMEIRO_GRAU',
  SEGUNDO_GRAU = 'SEGUNDO_GRAU',
  TERCEIRO_GRAU = 'TERCEIRO_GRAU',
  QUARTO_GRAU = 'QUARTO_GRAU'
}
